<template>
  <div>
    <div id="main-wrapper">
      <div class="content-body pt-0">
        <div class="container-fluid">
          <div class="form-head d-flex flex-wrap align-items-center pt-3">
            <h2 class="font-w600 title mb-5 mr-auto">
              Email Logs
            </h2>
          </div>

          <div class="row">
            <div class="col-xl-12 mar-bo">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <!-- <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[22].Email[0].Email_Contents }}
                  </h4> -->
                </div>
                <div class="card-body tab-content">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Message</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in emailLogs"
                            :key="item.id"
                            class="pointer"
                          >
                            <td>{{ item.date }}</td>
                            <td>{{ item.message }}</td>
                          </tr>
                          <div class="lds-ellipsis" v-show="value">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </tbody>
                      </table>
                      <span v-if="!value && !emailLogs && !emailLogs.length" >No Emails logs found</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios, { formToJSON } from "axios";
// import Editor from '@tinymce/tinymce-vue'
// import _ from 'lodash';

export default {
  name: "Email Template",
  // components: {
  //   Editor
  // },
  data() {
    return {
      emailLogs: [],
      ln: "",

      value: false,
    };
  },
  mounted() {
    // for top load page
    window.scrollTo(0, 0);

    this.emailLogsLoad("mount");
  },

  computed: {
    lan() {
      return this.$store.getters.whichLanguage;
    },
  },

  methods: {
    emailLogsLoad(text) {
      this.value = true;
      console.log(text);
      axios
        .get(axios.defaults.baseURL + "email-logs", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          const rawData = res?.data?.data;
          this.emailLogs = rawData
            .split(/\r?\n/)
            .filter(line => line.trim() !== '')
            .map(line => {
              // Split by first tab for date and message, since your example uses tab
              const firstTabIdx = line.indexOf('\t');
              let date = '', message = '';
              if (firstTabIdx !== -1) {
                date = line.slice(0, firstTabIdx).trim();
                message = line.slice(firstTabIdx + 1).trim();
              } else {
                // fallback to splitting by ->
                const [d, m] = line.split('->').map(s => s.trim());
                date = d || '';
                message = m || '';
              }
              return { date, message };
            })
            .sort((a, b) => {
              // Sort descending (latest date top)
              if (a.date && b.date) {
                return new Date(b.date) - new Date(a.date);
              }
              return 0;
            });

          this.value = false;
        })
        .catch((err) => {
            console.log('error--', err);
            
          this.value = false;
          this.$store.dispatch("checkErrorAndSendToast", [
            err.response,
            "error",
          ]);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader-show {
  display: none;
}
</style>
